import React, { useState } from "react";
import { Form, Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./Change_Password.css";
import User_Info from "../../common_components/user_info/User_Info";
import { useDispatch } from "react-redux";
import { AuthChangePassword } from "../../../features/auth/Slice";
import { FaEye, FaEyeSlash } from "react-icons/fa";
const Change_Password = () => {
  const dispatch = useDispatch();

  const [success, setSuccess] = useState("");
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const onSubmit = async (data) => {
    console.log("Form Data: ", data);
    const result = await dispatch(AuthChangePassword(data));

    if (result.payload.success) {
      setSuccess("Password changed successfully!");
      reset();
      setTimeout(() => {
        setSuccess("");
      }, 3000);
    } else {
      await setError("old_password", {
        type: "manual",
        message: result.payload.errors.old_password?.msg,
      });
      await setError("password", {
        type: "manual",
        message: result.payload.errors.password?.msg,
      });
    }
  };

  return (
    <section className="Manage_My_Points Change_Password">
      <div className="user_info_div">
        <div className="row me-0 ms-0">
          <div className="col-lg-3 col-sm-8 col-12 my-3">
            <User_Info />
          </div>
        </div>
      </div>

      <div className="note_info_div">
        <div className="row me-0 ms-0">
          <div className="col-xxl-2 col-lg-3 col-md-6 order-lg-1 order-1 mb-2"></div>

          <div className="col-xxl-8 col-lg-6 col-md-12 order-lg-2 order-3 mb-2">
            {success && (
              <div className="alert alert-success" role="alert">
                {success}
              </div>
            )}
            <div>
              <div className="manage_points_main_div mt-2">
                <div className="title_div">
                  <p className="title_text">:: Change Password</p>
                </div>

                <div className="transfer_form_div">
                  <Form>
                    <div className="inputs_div">
                      <Form.Group className="common_form_group" controlId="">
                        <Form.Label>Old Password:</Form.Label>
                        <Form.Control
                          type="text"
                          name="old_password"
                          {...register("old_password", {
                            required: "Old Password is required",
                          })}
                          placeholder="Enter Old Password"
                          autoComplete="off"
                          autoFocus
                        />
                      </Form.Group>
                      {errors.old_password && (
                        <sub className="text-danger">
                          {errors.old_password.message}
                        </sub>
                      )}

                      <Form.Group className="common_form_group password_holder">
                        <Form.Label>New Password:</Form.Label>
                        <div className="password_eye_field">
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            name="password"
                            {...register("password", {
                              required: "New Password is required",
                            })}
                            placeholder="Enter New Password"
                            autoComplete="off"
                            autoFocus
                          />

                          <span
                            className="password_eye_icon"
                            onClick={() => setShowPassword((prev) => !prev)}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                      </Form.Group>

                      {errors.password && (
                        <sub className="text-danger">
                          {errors.password.message}
                        </sub>
                      )}

                      <Form.Group className="common_form_group">
                        <Form.Label>Confirm New Password:</Form.Label>
                        <div className="password_eye_field">
                          <Form.Control
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirm_password"
                            {...register("confirm_password", {
                              required: "Confirm New Password is required",
                              validate: (value) =>
                                value === getValues("password") ||
                                "Passwords do not match",
                            })}
                            placeholder="Confirm New Password"
                            autoComplete="off"
                          />

                          <span
                            className="password_eye_icon"
                            onClick={() =>
                              setShowConfirmPassword((prev) => !prev)
                            }
                          >
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                      </Form.Group>

                      {errors.confirm_password && (
                        <sub className="text-danger">
                          {errors.confirm_password.message}
                        </sub>
                      )}
                    </div>
                  </Form>

                  <div className="form_footer">
                    <div className="btn_holder">
                      <button
                        className="blue_btn"
                        type="button"
                        onClick={handleSubmit(onSubmit)}
                      >
                        Change
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxl-2 col-lg-3 col-md-6 order-lg-3 order-2 mb-2"></div>
        </div>
      </div>
    </section>
  );
};

export default Change_Password;
